module.exports = __webpack_public_path__ + "img/London.72a59ae6.jpg";